/**
 * 动态加载script标签到HTML头部
 * @param options.src script src地址，默认 https://cms.jtexpress.com/common/JMS/Bonree/BonreeSDK_JS.min.js
 * @param options.data script data属性值
 * @param options.id script标签id，默认 BonreeAgent
 */
interface LoadScriptOptions {
  src?: string
  data?: string
  id?: string
}

export function loadMonitorSDK(options: LoadScriptOptions = {}) {
  const { src = 'https://cms.jtexpress.com/common/JMS/Bonree/BonreeSDK_JS.min.js', data, id = 'BonreeAgent' } = options

  if (document.getElementById(id)) {
    console.warn(`[Monitor] ${id} 已加载，跳过重复加载`)
    return
  }

  const script = document.createElement('script')
  script.id = id
  script.type = 'text/javascript'
  script.src = src

  if (data) {
    script.setAttribute('data', data)
  }

  script.onload = () => console.log(`[Monitor] ${id} 加载成功`)
  script.onerror = () => console.error(`[Monitor] ${id} 加载失败`)

  document.head.appendChild(script)
}

/**
 * 设置 Bonree RUM 用户 ID
 */
export const setBonreeUserId = (userId?: string | number) => {
  try {
    const br = (window as any).bonreeRUM
    if (userId && br && typeof br.setUserID === 'function') {
      br.setUserID(String(userId))
    }
  } catch (error) {
    console.error('bonreeRUM setUserID error:', error)
  }
}

export default loadMonitorSDK
